import energyAudit from "./energy-audit.jpg";
import electricalPanel from "./electrical-panel.jpg";
import evCharger from "./ev-charger.jpg";
import lightingRetrofit from "./lighting-retrofit.jpg";
import emergencyElectrician from "./emergency-electrician.jpg";
import generatorInstallation from "./generator-installation.jpg";
import surgeProtection from "./surge-protection.jpg";
import outdoorLighting from "./outdoor-lighting.jpg";
import hvacMaintenance from "./hvac-maintenance.jpg";
import licensedElectrician from "./licensed-electrician.jpg";
import elizabethtownElectrical from "./elizabethtown-electrical.jpg";
import shepherdsvilleIndustrial from "./shepherdsville-industrial.jpg";
import bardstownHvac from "./bardstown-hvac.jpg";
import newAlbanyLighting from "./new-albany-lighting.jpg";
import jeffersontownEnergy from "./jeffersontown-energy.jpg";
import mtWashingtonElectrical from "./mt-washington-electrical.jpg";
import laGrangeElectrical from "./la-grange-electrical.jpg";
import frankfortHvac from "./frankfort-hvac.jpg";
import lexingtonCommercial from "./lexington-commercial.jpg";
import simpsonvilleElectrical from "./simpsonville-electrical.jpg";
import stMatthewsElectrical from "./st-matthews-electrical.jpg";
import hillviewHvac from "./hillview-hvac.jpg";
import chooseCommercialContractor from "./how-to-choose-commercial-electrical-contractor.jpg";
import hvacPreventativeMaintenance from "./commercial-hvac-preventative-maintenance-cost-guide.jpg";
import sameDayElectrical from "./same-day-electrical-service-what-to-expect.jpg";
import gasFurnaceMaintenance from "./gas-furnace-maintenance-checklist-kentucky.jpg";
import residentialEnergyAudit from "./residential-energy-audit-guide.jpg";
import commercialHvacSystems from "./guide-to-commercial-hvac-systems.jpg";
import commercialLightingLed from "./commercial-lighting-installation-led-retrofits.jpg";
import residentialPowerSystems from "./residential-power-systems-panels-generators.jpg";
import facilityEnergyMgmt from "./facility-energy-management-strategies.jpg";
import hvacInstallationLouisville from "./hvac-installation-louisville-ky-costs-timeline.jpg";
import solarPanelInstallation from "./solar-panel-installation-louisville.jpg";
import residentialElectricalServices from "./residential-electrical-services.jpg";
import commercialLightingDesign from "./commercial-lighting-design.jpg";
import electricalServiceUpgrades from "./electrical-service-upgrades.jpg";
import electricianLexington from "./electrician-lexington-ky.jpg";
import hvacMaintenanceGuide from "./hvac-maintenance-guide.jpg";
import saveElectricityBills from "./save-electricity-bills.jpg";
import energyFinancingGuide from "./energy-financing-guide.jpg";
import commercialLedRetrofitGuide from "./commercial-led-retrofit-guide.jpg";
import hvacElectricalCompanyLouisville from "./hvac-electrical-company-louisville.jpg";
import electricalCompanyLouisville from "./electrical-company-louisville-ky.jpg";
import commercialElectricalServicesLouisville from "./commercial-electrical-services-louisville-ky.jpg";
import commercialElectricianLouisville from "./commercial-electrician-louisville-ky.jpg";
import commercialVsEnergyMgmt from "./commercial-electrician-vs-energy-management-contractor.webp";
import ashraeLevel2Cost from "./ashrae-level-2-audit-cost-kentucky.webp";
import oneContractorElectricalHvac from "./can-one-company-handle-both-my-electrical-and-havc.webp";
import emergencyElectrician24Hour from "./24-hour-emergency-electrician-louisville.webp";
import commercialElectricianServicesLouisville from "./commercial-electrician-services-louisville-ky.jpg";
import commercialElectricalRepairIssues from "./commercial-electrical-repair-common-issues.webp";


export const blogImages: Record<string, string> = {
  "energy-audit-louisville-ky": energyAudit,
  "electrical-panel-upgrade-louisville-ky": electricalPanel,
  "ev-charger-installation-louisville-ky": evCharger,
  "commercial-lighting-retrofit-louisville-ky": lightingRetrofit,
  "emergency-electrician-louisville-southern-indiana": emergencyElectrician,
  "generator-installation-louisville-ky": generatorInstallation,
  "whole-house-surge-protection-louisville-ky": surgeProtection,
  "outdoor-commercial-lighting-louisville-ky": outdoorLighting,
  "commercial-hvac-maintenance-louisville-ky": hvacMaintenance,
  "how-to-hire-electrician-louisville-ky": licensedElectrician,
  "commercial-electrician-elizabethtown-ky": elizabethtownElectrical,
  "industrial-electrical-shepherdsville-ky": shepherdsvilleIndustrial,
  "hvac-services-bardstown-ky": bardstownHvac,
  "commercial-lighting-new-albany-in": newAlbanyLighting,
  "energy-management-jeffersontown-ky": jeffersontownEnergy,
  "electrical-services-mt-washington-ky": mtWashingtonElectrical,
  "residential-electrician-la-grange-ky": laGrangeElectrical,
  "hvac-services-frankfort-ky": frankfortHvac,
  "commercial-electrical-lexington-ky": lexingtonCommercial,
  "electrical-services-simpsonville-ky": simpsonvilleElectrical,
  "commercial-electrician-st-matthews-ky": stMatthewsElectrical,
  "hvac-electrical-hillview-ky": hillviewHvac,
  "how-to-choose-commercial-electrical-contractor": chooseCommercialContractor,
  "commercial-hvac-preventative-maintenance-cost-guide": hvacPreventativeMaintenance,
  "same-day-electrical-service-what-to-expect": sameDayElectrical,
  "gas-furnace-maintenance-checklist-kentucky": gasFurnaceMaintenance,
  "residential-energy-audit-guide": residentialEnergyAudit,
  "guide-to-commercial-hvac-systems": commercialHvacSystems,
  "commercial-lighting-installation-led-retrofits": commercialLightingLed,
  "residential-power-systems-panels-generators": residentialPowerSystems,
  "facility-energy-management-strategies": facilityEnergyMgmt,
  "hvac-installation-louisville-ky-costs-timeline": hvacInstallationLouisville,
  "solar-panel-installation-louisville-ky": solarPanelInstallation,
  "residential-electrical-services-louisville-ky": residentialElectricalServices,
  "commercial-lighting-design-louisville-ky": commercialLightingDesign,
  "electrical-service-upgrades-louisville-ky": electricalServiceUpgrades,
  "electrician-lexington-ky-guide": electricianLexington,
  "hvac-maintenance-service-complete-guide": hvacMaintenanceGuide,
  "save-on-electricity-bills-energy-audit": saveElectricityBills,
  "financing-energy-efficiency-rebates-guide": energyFinancingGuide,
  "commercial-led-retrofit-upgrade-guide": commercialLedRetrofitGuide,
  "hvac-electrical-company-louisville-ky": hvacElectricalCompanyLouisville,
  "electrical-company-louisville-ky": electricalCompanyLouisville,
  "commercial-electrical-services-louisville-ky": commercialElectricalServicesLouisville,
  "commercial-electrician-louisville-ky": commercialElectricianLouisville,
  "commercial-electrician-vs-energy-management-contractor": commercialVsEnergyMgmt,
  "ashrae-level-2-audit-cost-kentucky": ashraeLevel2Cost,
  "can-one-company-handle-both-my-electrical-and-havc": oneContractorElectricalHvac,
  "24-hour-emergency-electrician-louisville": emergencyElectrician24Hour,
  "commercial-electrician-services-louisville-ky": commercialElectricianServicesLouisville,
  "commercial-electrical-repair-common-issues": commercialElectricalRepairIssues,
};

